/**
 * UpdatePrompt — shows a persistent toast when a new service worker version is available
 */
import { useEffect, useRef } from 'react';
import useServiceWorker from '../../hooks/useServiceWorker';
import { useToast } from './ToastContext';

const UpdatePrompt = () => {
  const { needRefresh, updateServiceWorker } = useServiceWorker();
  const { addToast } = useToast();
  const shownRef = useRef(false);

  useEffect(() => {
    if (needRefresh && !shownRef.current) {
      shownRef.current = true;
      addToast({
        message: 'A new version is available',
        type: 'info',
        duration: 0,
        action: {
          label: 'Update',
          onClick: () => updateServiceWorker(true),
        },
      });
    }
  }, [needRefresh, addToast, updateServiceWorker]);

  return null;
};

export default UpdatePrompt;
